import { Message } from 'iview';
import store from '../store';

import utils from '../libs/utils';
import axios from './axios';

const baseUrl = 'v1/erp-base-web';
const biz = 'v1/erp-business-web';
// const baseUrl = '';
export default {
  axios,
  hospital: {
    getHospitalList(params) { // 医院列表
      return axios.get(`${baseUrl}/hospital/list?${utils.exchangeParams(params)}`);
    },
    downloadHospitalList(params) { // 导出医院列表
      return axios.get(`${baseUrl}/hospital/list/download?${utils.exchangeParams(params)}`);
    },
    addHospital(params) { // 新建医院
      return axios.post(`${baseUrl}/hospital/add`, utils.exchangeParams(params));
    },
    editHospital(params) { // 编辑医院
      return axios.post(`${baseUrl}/hospital/edit`, utils.exchangeParams(params));
    },
    editStatusHospital(params) { // 编辑医院
      return axios.post(`${baseUrl}/hospital/editStatus?${utils.exchangeParams(params)}`);
    },
  },
  patient: {
    getListNation(params) { // 国家列表
      return new Promise((resolve, reject) => {
        if (store.state.app.listNation) {
          resolve(true);
        }
        axios.get(`${baseUrl}/patient/listNation?${utils.exchangeParams(params)}`).then((res) => {
          if (res.data.status === 200) {
            store.commit('setListNation', res.data.data);
            resolve(true);
          } else {
            Message.error(res.data.error);
          }
        }).catch((err) => {
          reject(err);
          utils.handleError(err);
        });
      });
    },
    getListEthnicity(params) { // 民族列表
      return new Promise((resolve, reject) => {
        if (store.state.app.listEthnicity) {
          resolve(true);
        }
        axios.get(`${baseUrl}/patient/listEthnicity?${utils.exchangeParams(params)}`).then((res) => {
          if (res.data.status === 200) {
            store.commit('setListEthnicity', res.data.data);
            resolve(true);
          } else {
            Message.error(res.data.error);
          }
        }).catch((err) => {
          reject(err);
          utils.handleError(err);
        });
      });
    },
    getPatientList(params) { // 患者列表
      return axios.get(`${baseUrl}/patient/list?${utils.exchangeParams(params)}`);
    },
    downloadPatientList(params) { // 导出患者列表
      return axios.get(`${baseUrl}/patient/list/download?${utils.exchangeParams(params)}`);
    },
    getPatientBaseInfo(params) { // 患者基础详情
      return axios.get(`${baseUrl}/patient/baseInfo?${utils.exchangeParams(params)}`);
    },
    editPatient(params) { // 编辑患者
      return axios.post(`${baseUrl}/patient/edit`, utils.exchangeParams(params));
    },
    getPatientInquiryList(params) { // 用药咨询列表
      return axios.get(`${baseUrl}/patientInquiry/list?${utils.exchangeParams(params)}`);
    },
    downloadPatientInquiryList(params) { // 导出用药咨询列表
      return axios.get(`${baseUrl}/patientInquiry/list/download?${utils.exchangeParams(params)}`);
    },

    editPatientInquiry(params) { // 编辑患者用药咨询
      return axios.post(`${baseUrl}/patientInquiry/edit`, utils.exchangeParams(params));
    },
    addPatientInquiry(params) { // 新建患者用药咨询
      return axios.post(`${baseUrl}/patientInquiry/add`, utils.exchangeParams(params));
    },
    getPatientInquiryInfo(params) { // 详情患者用药咨询
      return axios.get(`${baseUrl}/patientInquiry/info?${utils.exchangeParams(params)}`);
    },
    getPatientRebuyList(params) { // 患者复购统计
      return axios.get(`${biz}/patientRebuy/list?${utils.exchangeParams(params)}`);
    },
    downloadPatientRebuyList(params) { // 患者复购统计导出
      return axios.get(`${biz}/patientRebuy/list/export?${utils.exchangeParams(params)}`);
    },
    getPatientRebuyCount(params) { // 患者数量统计
      return axios.get(`${biz}/patientRebuy/count?${utils.exchangeParams(params)}`);
    },
    getPatientRebuyListReason(params) { // 患者管理-未复购原因补充
      return axios.get(`${biz}/patientRebuy/listReason?${utils.exchangeParams(params)}`);
    },
    editPatientRebuyListReason(params) { // 患者管理-更新未复购原因补充
      return axios.post(`${biz}/patientRebuy/edit`, utils.exchangeParams(params));
    },
    downLoadPatientRebuyListReason(params) { // 患者管理-未复购原因补充下载
      return axios.get(`${biz}/patientRebuy/noRebuyReason/export?${utils.exchangeParams(params)}`);
    },
    downloadPatientFollowUpList(params) { // 药事随访管理导出excel
      return axios.get(`${biz}/pharmaceuticalCare/download?${utils.exchangeParams(params)}`);
    },
    downloadFollowList(params) { // 随访统计导出
      return axios.get(`/v1/erp-report-web/report/pharmacy/download?${utils.exchangeParams(params)}`);
    },
    getPatientInterviewRecordList(params) { // 患者药历信息打印
      return axios.get(`${biz}/pharmaceuticalCare/interviewRecord?${utils.exchangeParams(params)}`);
    },
  },
  goods: {
    getConcactList(params) {
      return axios.get(`/v1/erp-business-web/contact/getContactList?${utils.exchangeParams(params)}`);
    },
  },
};
